<template>
  <el-card v-loading.lock="loading" class="box-card">
    <div slot="header" class="clearfix">
      <el-input v-if="role=='admin'" v-model="data.judul"></el-input>
      <span class="card-header" v-else>{{data.judul}}</span>
    </div>
    <div v-if="role=='admin'">
      <vue-editor v-model="data.data" useCustomImageHandler @image-added="saveImage" @image-removed="deleteImage"/>
      <el-button @click="simpan()" style="margin-top:10px">Simpan</el-button>
      <el-button v-if="sub!='tambah'" @click="hapus()" style="margin-top:10px">Hapus Sub Item</el-button>
    </div>
    <div v-else v-html="data.data"></div>
  </el-card>
</template>

<script>
import { database, storage } from '../firebase'
import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      data: {
        judul: 'memuat . . .',
        data: 'memuat . . .'
      },
      role: this.$store.state.user.displayName,
      loading: false,
      errorForm: {
        email: null
      },
      id: '',
      daftar: []
    }
  },
  watch: {
    $route() {
      this.loadPage()
    }
  },
  props: {
    halaman: String,
    sub: String
  },
  components: {
    VueEditor
  },
  mounted() {
    this.loadPage()
  },
  methods: {
    loadPage: function() {
      if (this.sub != 'tambah') {
        let modulRef = database.ref('isi/'+this.halaman+'/sub/'+this.sub)
        modulRef.on('value', (snapshot) => {
          if (snapshot.val()) {
            this.data = snapshot.val()
          }
        })
        this.id = this.sub
      } else {
        this.data = {
          judul: '',
          data: ''
        }
        this.id = this.rndStr(10)
      }
      let daftarRef = database.ref('menu/'+this.halaman+'/daftar')
      daftarRef.on('value', (snapshot) => {
        if (snapshot.val()) {
          this.daftar = snapshot.val().split(',')
        }
      })
    },
    rndStr: function (len) {
      let text = ""
      let chars = "abcdefghijklmnopqrstuvwxyz"
      for( let i=0; i < len; i++ ) {
        text += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return text
    },
    saveImage: function(file, Editor, cursorLocation, resetUploader) {
      
      var formData = new FormData();
      formData.append("image", file);

      var ref = storage.ref(this.rndStr(10))
      ref.put(file)
        .then(() => {
          ref.getDownloadURL()
            .then((downloadURL) => {
              Editor.insertEmbed(cursorLocation, "image", downloadURL);
              resetUploader();
            })
            .catch((error) => {
              this.$notify.error({
                title: 'Error',
                message: error
              });
            })
        })
        .catch((error) => {
          this.$notify.error({
            title: 'Error',
            message: error
          });
        })

    },
    deleteImage: function(image) {
      image
    },
    simpan: function() {
      this.loading = true

      if (!(this.daftar.includes(this.id))) {
        this.daftar.push(this.id)
      }

      var update = {}
      update['isi/'+this.halaman+'/sub/'+this.id] = this.data
      update['menu/'+this.halaman+'/'+this.id+'/judul'] = this.data.judul
      update['menu/'+this.halaman+'/daftar'] = this.daftar.join(',')
      database.ref().update(update).then(()=>{
        this.loading = false;
        this.$notify({
          title: 'Sukses',
          message: 'Pembaruan telah tersimpan',
          type: 'success'
        });
        this.$router.push({name: this.halaman, params: {id: this.id}})
      }).catch((error) => {
        this.loading = false
        this.$notify.error({
          title: 'Error',
          message: error
        });
      })      
    },
    hapus: function() {
      this.$confirm('Apakah anda yakin akan menghapus sub item ini?', 'Peringantan', {
        confirmButtonText: 'Hapus',
        cancelButtonText: 'Batal',
        type: 'warning'
      }).then(() => {
        this.loading = true
        
        var data = []
        for (var i in this.daftar) {
          if (this.daftar[i] != this.sub) {
            data.push(this.daftar[i])
          }
        }

        this.daftar = data

        var update = {}
        update['menu/'+this.halaman+'/daftar'] = this.daftar.join(',')
        update['isi/'+this.halaman+'/sub/'+this.sub] = null
        database.ref().update(update).then(()=>{
          this.loading = false;
          this.$notify({
            title: 'Sukses',
            message: 'Sub telah terhapus',
            type: 'success'
          });
          this.$router.push({name: this.halaman, params: {id: 'tambah'}})
        }).catch((error) => {
          this.loading = false
          this.$notify.error({
            title: 'Error',
            message: error
          });
        })  
      }).catch(() => {
                  
      });
    }
  }
}
</script>
